// Define types for the color palettes
export interface ColorPalette {
  [key: number]: string;
}

export const black: ColorPalette = {
  10: "hsl(0, 0%, 96%)",
  20: "hsla(0, 0%, 0%, 5%)",
  500: "hsl(0, 0%, 7%)",
  700: "hsl(0, 0%, 0%)",
  800: "hsl(0, 0%, 0%)",
};

export const eclipse: ColorPalette = {
  10: "hsl(0, 0%, 96%)",
  20: "hsla(0, 0%, 20%, 5%)",
  500: `hsl(0, 0%, ${20 + 7}%)`,
  700: "hsl(0, 0%, 20%)",
  800: `hsl(0, 0%, ${20 - 4}%)`,
};

export const ferra: ColorPalette = {
  10: "hsl(350, 35%, 96%)",
  20: "hsla(350, 15%, 45%, 5%)",
  500: `hsl(350, 15%, ${45 + 7}%)`,
  700: "hsl(350, 15%, 45%)",
  800: `hsl(350, 15%, ${45 - 4}%)`,
};

export const contessa: ColorPalette = {
  10: "hsl(20, 20%, 95%)",
  20: "hsla(20, 45%, 42%, 5%)",
  500: "hsl(20, 45%, 49%)",
  700: "hsl(20, 45%, 42%)",
  800: "hsl(20, 45%, 38%)",
};

export const sorbus: ColorPalette = {
  10: "hsl(30, 40%, 95%)",
  20: "hsla(25, 85%, 50%, 5%)",
  500: "hsl(25, 85%, 57%)",
  700: "hsl(25, 85%, 50%)",
  800: "hsl(25, 85%, 46%)",
};

export const lime: ColorPalette = {
  10: "hsl(75, 45%, 94%)",
  20: "hsla(75, 85%, 35%, 8%)",
  500: "hsl(75, 85%, 42%)",
  700: "hsla(75, 100%, 29%, 1.00)",
  800: "hsla(75, 98%, 25%, 1.00)",
};

export const green: ColorPalette = {
  10: "hsl(110, 25%, 95%)",
  20: "hsla(130, 65%, 42%, 5%)",
  500: "hsl(130, 65%, 49%)",
  700: "hsl(130, 65%, 42%)",
  800: "hsl(130, 65%, 38%)",
};

export const como: ColorPalette = {
  10: "#F8F8F7",
  20: "hsla(154, 24%, 36%, 5%)",
  50: "#e3f1ed",
  100: "#bcdcd2",
  200: "#94c6b6",
  300: "#71b09b",
  400: "#5e9f88",
  500: "#528e77",
  600: "#4c816c",
  700: "hsl(154, 24%, 36%)",
  800: "#3e6151",
  900: "#31453a",
};

export const mint: ColorPalette = {
  10: "hsl(170, 25%, 95%)",
  20: "hsla(170, 65%, 40%, 5%)",
  500: "hsl(170, 65%, 47%)",
  700: "hsl(170, 65%, 40%)",
  800: "hsl(170, 65%, 36%)",
};

export const danube: ColorPalette = {
  10: "hsl(200, 35%, 96%)",
  20: "hsla(200, 45%, 45%, 5%)",
  500: `hsl(200, 45%, ${45 + 7}%)`,
  700: "hsl(200, 45%, 45%)",
  800: `hsl(200, 45%, ${45 - 4}%)`,
};

export const denim: ColorPalette = {
  10: "hsl(210, 40%, 96%)",
  20: "hsla(210, 85%, 45%, 5%)",
  500: `hsl(210, 85%, ${45 + 7}%)`,
  700: "hsl(210, 85%, 45%)",
  800: `hsl(210, 85%, ${45 - 4}%)`,
};

export const blueViolet: ColorPalette = {
  10: "hsl(270, 40%, 96%)",
  20: "hsla(270, 85%, 45%, 5%)",
  500: `hsl(270, 85%, ${45 + 7}%)`,
  700: "hsl(270, 85%, 45%)",
  800: `hsl(270, 85%, ${45 - 4}%)`,
};

export const deepLilac: ColorPalette = {
  10: "hsl(280, 35%, 96%)",
  20: "hsla(280, 45%, 45%, 5%)",
  500: `hsl(280, 45%, ${45 + 7}%)`,
  700: "hsl(280, 45%, 45%)",
  800: `hsl(280, 45%, ${45 - 4}%)`,
};

export const royalHeath: ColorPalette = {
  10: "hsl(320, 35%, 96%)",
  20: "hsla(320, 45%, 45%, 5%)",
  500: `hsl(320, 45%, ${45 + 7}%)`,
  700: "hsl(320, 45%, 45%)",
  800: `hsl(320, 45%, ${45 - 4}%)`,
};

export const darkPink: ColorPalette = {
  10: "hsl(330, 40%, 96%)",
  20: "hsla(330, 85%, 55%, 5%)",
  500: `hsl(330, 85%, ${55 + 7}%)`,
  700: "hsla(330, 79%, 55%, 1.00)",
  800: `hsl(330, 85%, ${55 - 4}%)`,
};

// Map all the available palettes using an object
export const allPalettes: Record<string, ColorPalette> = {
  como,
  ferra,
  eclipse,
  black,
  sorbus,
  darkPink,
  denim,
  blueViolet,
  contessa,
  royalHeath,
  danube,
  deepLilac,
  mint,
  green,
  lime,
};
